"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function _defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);
    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }
  return obj;
}

/**
 * Make a shallow copy of the object maintaining the prototype.
 */

exports.default = function (source) {
  var target = void 0;
  if (source.constructor === Array) {
    target = source.map(function (element) {
      return element;
    });
  } else {
    target = {};
    for (var property in source) {
      if (source.hasOwnProperty(property)) {
        target[property] = source[property];
      }
    }
  }
  _defaults(target, Object.getPrototypeOf(source));
  return target;
};
module.exports = exports['default'];